export const gitHash={ hash: "a4ec403857ea3d9e0142a97d0a105969980d9ab7", date: "2022-01-22T18:52:23+00:00" }
